var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 12.329V1.5C11 1.224 10.776 0.999984 10.5 0.999984C4.71 0.999984 0 6.159 0 12.5C0 18.8409 5.15902 24 11.5 24C14.337 24 15.872 23.486 17.818 21.886C18.027 21.714 18.061 21.407 17.895 21.193L11 12.329ZM11.5 23C5.70998 23 0.999984 18.29 0.999984 12.5C0.999984 6.89601 4.99298 2.30302 9.99998 2.01403V12.5C9.99998 12.611 10.037 12.719 10.106 12.807L16.802 21.416C15.223 22.622 13.906 23 11.5 23Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 12H23.5C23.776 12 24 11.776 24 11.5C24 5.15902 18.841 0 12.5 0C12.224 0 12 0.224016 12 0.500016V11.5C12 11.776 12.224 12 12.5 12ZM13 1.01198C18.393 1.266 22.734 5.607 22.988 11H13V1.01198Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.5 13H13.5C13.308 13 13.131 13.111 13.048 13.285C12.965 13.459 12.99 13.665 13.111 13.814L19.611 21.861C19.698 21.9699 19.826 22.0359 19.965 22.046C19.977 22.047 19.988 22.047 20 22.047C20.126 22.047 20.248 21.999 20.341 21.9129C22.666 19.744 24 16.678 24 13.5C24 13.224 23.776 13 23.5 13ZM20.043 20.804L14.547 14H22.988C22.865 16.542 21.813 18.973 20.043 20.804Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPie);
export default __webpack_public_path__ + "static/media/icon-pie.4816ba196e0ed062c9295da3cc3af7b6.svg";
export { ForwardRef as ReactComponent };